<footer> &copy; {{currentYear}} - {{currentYear+1}} <span i18n="@@Common.Footer.Label">Eurofins Scientific | Testing laboratories company</span></footer>
